<template>

    <div class="userPanel">
        <router-link :to="{name: 'login'}" v-if="!isLogged">Войти</router-link>
        <div @mouseover="showMenu=true" @mouseout="showMenu=false" style="position: relative; text-align: center"
             v-if="isLogged">
            {{ shortName }}
            <div class="logout"><button class="btn-link" @click="logout()"><i class="fi-close"></i> Выйти</button></div>
            <div id="userMenu" v-if="0">
                <ul class="vertical menu">
                    <li>{{user.login}}</li>
                    <li>{{date(user.iat)}}</li>
                    <li><a href="#">Настройки</a></li>
                    <li><a @click="logout()"><i class="fi-close"></i> Выйти</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import auth from '../auth/index'
    import {mapState, mapGetters} from 'vuex'

    export default {
        data() {
            return {
                showMenu: false
            }
        },

        computed: {
            user() {
                return this.$store.state.auth.user;
            },
            isLogged() {
                return this.$store.getters['auth/isLogged'];
            },
            shortName() {
                return this.$store.getters['auth/shortName'];
            }
        },

        methods: {
            logout() {

                vex.dialog.confirm({
                    message: 'Вы уверены, что хотите выйти из аккаунта?',
                    callback: (value) => {
                        if (value) {
                            auth.logout(this);
                        }
                    }
                })
            }
        }

    }
</script>

<style lang="scss">

    .userPanel:hover .logout {
        display: block;
    }

    .logout {
        display: none;
    }

    @media (max-width: 991px){
        .logout {
            display: block;
        }
    }


    #userMenu {
        position: fixed;
        bottom: 0;
        left: 55px;
        background: #F0F0F0;
        padding: 1em 0 0 0;
        font-size: 80%;
        text-align: center;
        z-index: 100;

    }

    .userPanel .shortname {
        color: #000;
        margin-bottom: 5px;
    }

    .userPanel .shortname:hover {
        text-decoration: underline;
    }
    
    .btn-link {
        padding: 0 1em;
        background-color: transparent;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// UserPanel.vue?a76fc154